var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.categories.length)?_c('div',{staticClass:"StoryCategoriesList flex flex-col gap-1 font-display text-sm leading-snug text-muted"},_vm._l((_vm.categories),function(cat){return _c('span',{key:cat.id,staticClass:"Category"},[_vm._v(" "+_vm._s(_vm.$t('categories.' + cat.id))+" ")])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }